"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchParams = exports.generateUUID = void 0;
function generateUUID() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' &&
        typeof performance.now === 'function') {
        d += performance.now(); // use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}
exports.generateUUID = generateUUID;
const searchParams = (obj = {}) => '?' +
    Object.keys(obj)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
        .join('&');
exports.searchParams = searchParams;
//# sourceMappingURL=util.js.map